import { createBrowserClient as createSupabaseBrowserClient } from '@supabase/ssr';
import type { SupabaseClient } from '@supabase/supabase-js';
import type { Database } from '@/lib/database/types';

export type BrowserSupabaseClient = SupabaseClient<Database>;

let browserClient: BrowserSupabaseClient | null = null;

export function createBrowserClient(): BrowserSupabaseClient {
  if (!browserClient) {
    const url = process.env.NEXT_PUBLIC_SUPABASE_URL;
    const anon = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY;
    if (!url || !anon) {
      // Create a no-op client by throwing a clear error to be caught by callers.
      // Avoid calling into @supabase/ssr with invalid URL which throws synchronously.
      throw new Error('Supabase URL/Anon key missing');
    }
    browserClient = createSupabaseBrowserClient<Database>(url, anon);
  }
  return browserClient;
}

// Backward compatibility
export function createClient(): BrowserSupabaseClient {
  return createBrowserClient();
}
